import React, { useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./HomePage.css";

const HomePage = () => {
  const images = [
    "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1761821013/certificate-removebg-preview_lbydgu.png",
    "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1762147190/Screenshot_2025-11-03_104859-removebg-preview_k55h6x.png",
    "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1761896997/Screenshot_2025-10-30_160917_xvmy68-removebg-preview_ltnuwc.png",
    "https://res.cloudinary.com/dmv2tjzo7/image/upload/v1738302760/x0gpgusknr2p2lfadmz3.png",
  ];

  const [currentImage, setCurrentImage] = useState(0);

  // Automatically switch images every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 3000);
    return () => clearInterval(interval);
  }, [images.length]);

  const handleDownload = () => {
    // Replace this with your actual file URL or API endpoint
    const fileUrl = "/downloads/GCS_V3.3.4_NG_DRONE_ALPHA.rar"; 
    const link = document.createElement("a");
    link.href = fileUrl;
    link.download = "GCS_3.3.4";
    link.click();
  };

  return (
    <div className="container-fluid zuppa_home_pg_wrapper py-5">
      <div className="container">
        <div className="row align-items-center">
          
          {/* Left Section - Text Content */}
          <div className="col-lg-6 col-md-12 text-center text-lg-start">
            <h1 className="zuppa_home_pg_title">
              DGCA Compliant Indian Drone for RPTO with Economical Price
            </h1>
            <p className="zuppa_home_pg_subtitle">
              Elevate your UAV training with the AJEET Mini TRAINER (Master & Slave). 
             
            </p>

            {/* Software Download Section */}
            <div className="zuppa_home_pg_download_section mt-4">
              <p className="zuppa_home_pg_download_text">
                Download our latest <strong>GCS 3.3.4</strong> software for enhanced UAV control and real-time telemetry visualization.
              </p>
              <button
                className="zuppa_home_pg_download_btn"
                onClick={handleDownload}
              >
                ⬇ Download GCS 3.3.4
              </button>
            </div>
          </div>

          {/* Right Section - Auto-Changing Image */}
          <div className="col-lg-6 col-md-12 mt-4 mt-lg-0">
            <div className="zuppa_home_pg_video_wrapper">
              <img
                src={images[currentImage]}
                alt="Drone showcase"
                className="zuppa_home_pg_slideshow"
              />
            </div>
          </div>

        </div>
      </div>
    </div>
  );
};

export default HomePage;
